import styled from 'styled-components';

import colors from 'themes/Main';

const { blue, darkBlue, gray03, white } = colors;

export const AccordionContainer = styled.div``;

export const AccordionHead = styled.div`
  cursor: pointer;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-radius: 3px;
  padding: 16px 32px;
  margin-bottom: 16px;
  background-color: ${({ bgColor, hasBgColor }) =>
    hasBgColor && bgColor ? bgColor : !bgColor ? `${darkBlue}` : 'transparent'};

  &:hover p {
    color: ${({ hasBgColor }) =>
      hasBgColor ? 'rgba(255,255,255,.6)' : `${blue}`};
  }

  &:hover svg {
    transform: rotate(25deg);
  }
`;

export const AccordionHeadTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: ${({ hasBgColor }) => (hasBgColor ? `${white}` : `${darkBlue}`)};
  margin: 0;
  transition: all 0.3s ease-in;
`;

export const AccordionHeadIcon = styled.div`
  svg {
    transition: all 0.3s ease-in-out;
    transform: ${({ isAccordionOpen }) =>
      isAccordionOpen ? 'rotate(180deg)' : 'rotate(0deg)'};

    path {
      stroke: ${({ hasBgColor }) => (hasBgColor ? `${white}` : '')};
    }
  }
`;

export const AccordionContent = styled.div`
  margin-bottom: 16px;
  max-height: ${({ isAccordionOpen }) => (isAccordionOpen ? 'auto' : '0')};
  overflow: hidden;
  transition: all 0.25s ease-in-out;
`;

export const AccordionCallback = styled.div`
  cursor: default;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 130px;
  margin: 0 32px;
  padding: 32px;
  border: 1px dashed ${gray03};
  border-radius: 5px;
  opacity: 0.5;

  p {
    text-align: center;
    color: ${gray03};
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 0;
  }
`;
